import React from 'react'
import { CareTeamCarousel } from './CareTeamCarousel'
import { CareTeamGrid } from './CareTeamGrid'

type CareTeamProps = {
  _type: 'careTeam'
  title?: string
  subtitle?: string
  deepLinkId?: string
  providers?: any
  viewType?: 'grid' | 'carousel'
  backgroundColor?:
    | 'bcorange'
    | 'bcb'
    | 'bcw'
    | 'bcblue'
    | 'bcp'
    | 'bcbluetint'
    | 'bcotint'
    | 'bcgtint'
    | 'bcptint'
    | 'bcraspberry'
    | 'bcpoppy'
    | 'bcoat'
    | 'bccream'
    | 'bctran'
  visibleCount?: number
  showSpecialtyFilter?: boolean
  itemsPerRow?: number
  visibleItems?: number
}

const CareTeam: React.FC<{ data: CareTeamProps }> = ({ data }) => {
  const { viewType } = data

  return viewType === 'grid' ? (
    <CareTeamGrid data={data} />
  ) : (
    <CareTeamCarousel data={data} />
  )
}

export { CareTeam }
export type { CareTeamProps }
